import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import TaskPayload from '../schemas/TaskPayload'
import parseTask from 'parseTask'

export default DataRequest({
  schema: TaskPayload,
  url: '/api/learner/perform_tasks',

  parse(normalize, payload) {
    return payload.tasks.map(normalize)
      .map(parseTask)
  }
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/data_requests/getTasks.js